export const APP_NAME = process.env.REACT_APP_NAME || 'Tienda';
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';
export const APP_DESCRIPTION = process.env.REACT_APP_DESCRIPTION || 'Powering Sales, One Tap at a Time';
export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'development';
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
